module.exports = __webpack_public_path__ + "static/media/p6a2.63ada5fc.wav";